








































































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action, namespace } from 'vuex-class';

/**
 * Utils
 */
import { userLogin } from "@/utils/auth";

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * Components
 */
import ForgotPasswordDialog from './components/ForgotPasswordDialog.vue';

/**
 * API
 */
import authenticationAPI from '@/api/authentication';

/**
 * Types
 */
import { PayloadCredentialsRequest } from '@/api/authentication';
import { SettingsResponseModel } from '@/api/settings';

/**
 * VueX Modules
 */
const clientSettingsModule = namespace('settings');

/**
 * Page de login d'usager.
 */
@Component({
	components: { ForgotPasswordDialog },
	mixins: [mixinsAPI]
})
export default class LoginPage extends Vue {
	$refs!: {
		forgotPasswordDialog: ForgotPasswordDialog
	};

	/** VueX - Settings */
	@clientSettingsModule.Getter
	settings!: SettingsResponseModel;

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Attributs */
	isLoading = false;
	credentials = new PayloadCredentialsRequest();
	errors = {};

	/** Méthodes */
	async handleLogin() {
		this.isLoading = true;
		try {
			await userLogin(this.credentials, this.$router);
		}
		catch (err) {
			(this as any).handleAPIError(err);
			this.isLoading = false;
		}

	}

	async handleForgotPassword() {
		this.isLoading = true;
		try {
			this.errors = {};
			await authenticationAPI.forgotPassword(this.credentials.username);
			this.$refs.forgotPasswordDialog.open();
		}
		catch (err) {
			this.errors = (this as any).handleAPIError(err);
		}
		this.isLoading = false;
	}

	async handleActivateAccount() {
		this.$router.push(`activate`);
	}
}
